import styled from 'styled-components';

export default styled.div`
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    margin-bottom: 50px;
    @keyframes fadeIn {
      0% {opacity:0;}
      100% {opacity:1;}
    }
    .openFaq .Collapsible__contentInner {
      animation: fadeIn linear 0.6s;
    }
    ${props => props.theme.media.md} {
      padding-left: 0;
      padding-right: 0;
    }
    
    .container {
      h3 {
        font-weight: 600;
        text-align: center;
       
        color: #505050;
        max-width: 600px;
        margin: auto;
        line-height: 1.2;
        font-size: 24px;
        margin-bottom: 22px;
        ${props => props.theme.media.md} {
          font-size: 30px;
          margin-bottom: 75px;
          margin-top: 75px;
        }
        
      }

      .row {
        background: #fff; 
        border-top: 1px solid #ccc;
      
        .Collapsible {
          cursor: pointer;
          padding: 10px 0;
          transition: all 0.2s;
          &__trigger {
            cursor: pointer;
            display: block !important;
            padding: 4px 30px 4px 0;
            position: relative;
            font-size: 16px;
            font-weight: 500;
            color: #484646;
            width: 100%;
            text-align: left;
              text-transform: none;
            ${props => props.theme.media.md} {
              margin-bottom: 0px;
              text-align: left;
              font-size: 24px;
              padding-right: 40px;
              width: auto;
              text-transform: none;
            }
            &::after {
              color: #FE6712;
              content: '+';
              font-size: 2.3rem;
              font-weight: 300;
              line-height: 1;
              position: absolute;
              right: 0;
              top: 0px;
              transition: all 0.3s;
            }

            &.is-open {
              &::after {
                transform: rotate(135deg);
                color: #FE6712;
              }
            }
          }
          &__contentInner {
            font-size: 16px;
            font-height: 25px;
            padding: 10px 30px 10px 0;

            p {
              color: #464646;
              text-align: left;
              margin: 0;
              max-width: 1050px;
              width: 100%;
              font-size: 14px;
              ${props => props.theme.media.md} {
                 font-size: 16px;
                 text-align: left;
              }
            }
          }
        }
      }
    }
`;
